import type { MediaFileAsset } from '../../../../audio-form/data/dto/audio-form-input.ts'
import {
  type TracksStore,
  TrackType,
} from '../../../../../shared/store/tracks.store.tsx'

export const mapMediaFileClipsToAssets = (
  tracksStore: TracksStore
): Record<string, MediaFileAsset> => {
  let counter = 1

  return tracksStore.tracks.reduce<Record<string, MediaFileAsset>>(
    (acc, { type, clips }) => {
      if (type !== TrackType.MediaFiles) return acc

      for (const clip of clips) {
        acc[`media-${counter}`] = {
          type: 'media',
          fileId: clip.mediaId,
          ...(clip.src && { uri: clip.src }),
        }
        counter++
      }

      return acc
    },
    {}
  )
}
